


var Shopify = Shopify || {};
Shopify.queryParams = {};

function updateCollectionProducts() {
  let currentUrl = window.location.pathname;
  let queryParams = new URLSearchParams();

  if (Shopify.queryParams.sort_by) {
    queryParams.set("sort_by", Shopify.queryParams.sort_by);
  }



  var urlUpdate = `${currentUrl}?${queryParams.toString()}`;

  fetch("?section_id=main-collection&" + queryParams.toString())
    .then(res => res.text())
    .then(data => {
      var col = $(data);
      var card = $(".product-collection__grid", col);
      $(".product-collection__grid").replaceWith(card)

    })

  window.history.pushState({
    urlUpdate
  }, '', urlUpdate)

}


function sortBy(element) {
  var data = $(element).attr("data-src");
  Shopify.queryParams = Shopify.queryParams || {};
  Shopify.queryParams.sort_by = data;
  updateCollectionProducts()

}
